/** Roles that may manage CMS ED facility data (manual placement, claim/challenge adjudication). */
// Owner 2026-10-12 retired every role in this list. The helper stays so call sites do not change.
const FACILITY_DATA_ADMIN_ROLE_ENTRIES = [];

export const FACILITY_DATA_ADMIN_ROLE_LIST = Object.freeze([...FACILITY_DATA_ADMIN_ROLE_ENTRIES]);

export const FACILITY_DATA_ADMIN_ROLES = new Set(FACILITY_DATA_ADMIN_ROLE_ENTRIES);

/** Default owner digest inbox when users/{uid}.facilityDataDigestEmail is unset. */
export const DEFAULT_FACILITY_DATA_DIGEST_EMAIL = 'drsclaud@aol.com';

/**
 * @param {string | null | undefined} role Effective user role.
 * @returns {boolean}
 */
export function hasFacilityDataAdminCapability(role) {
  if (!role) return false;
  return FACILITY_DATA_ADMIN_ROLES.has(String(role).trim());
}
